import React, { useEffect, useState } from 'react';
import ToggleContent from './ToggleContent';
import ToggleSwitch from './ToggleSwitch';
import DropdownSelect from 'components/Core/DropdownSelect';

import { Container } from './styles';

const ContentfulToggle = ({
  backgroundColor,
  defaultValue,
  titles,
  type,
  heading,
  subheading,
  startingIndex,
  items,
}) => {
  const initialIndex = startingIndex || 0;
  const [indexSelected, toggleIndexSelected] = useState(initialIndex);
  const [checkedState, toggleCheckedState] = useState(false);

  useEffect(() => {
    initialIndex === 0 ? toggleCheckedState(false) : toggleCheckedState(true);
  }, []);

  const handleClick = value => {
    value ? toggleIndexSelected(value) : toggleIndexSelected(indexSelected === 0 ? 1 : 0);

    toggleCheckedState(!checkedState);
  };

  return (
    <Container backgroundColor={backgroundColor}>
      {heading && (
        <h2 fontSize="normal" style={{ textAlign: 'center', marginBottom: 40 }}>
          {heading}
        </h2>
      )}
      {type === 'dropdown' ? (
        <DropdownSelect handleSelect={handleClick} defaultValue={defaultValue} menuItems={titles} />
      ) : (
        <ToggleSwitch
          checkedState={checkedState}
          handleClick={handleClick}
          indexSelected={indexSelected}
          titles={titles}
        />
      )}

      {items.map((item, index) => (
        <div className={indexSelected === index ? 'show' : 'hide'} key={`toggle-content--${index}`}>
          <ToggleContent item={{ ...item, index }} />
        </div>
      ))}
    </Container>
  );
};

export default ContentfulToggle;
